import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import Properties from "../const/Properties";
import axios from 'axios';
import CustomTable from "../thema/tema1/component/CustomTable"

const active = {Home: "active"};
const turler = {
    1: "CEZA",
    2: "PARK",
};
class Sorgulama extends React.Component {
    componentDidMount() {

    }
    constructor(props){
        super(props);
        if(localStorage.getItem("token")=="")
        {
            window.location = '/';
            return false;
        }
        this.state = {
            plaka: "",
            odemeTuru: 0,
            odemeUcreti: 0,
            firmalar:[],
            content:[],
            pageCount:0,
            totalRow:0,
            startRow:0,
            endRow:0,
            silId:0,
            duzenleId:0,
            silModal:'none',
            title:["TIR PLAKA","İŞLEM","BORÇ BİLGİSİ"],
            showDuzenle:false,
            duzenle:false,
            error: 0
        };
    }
    handlePageClick=e=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/tasima/plakaSorgula/'+this.state.plaka.toUpperCase().replace(/\s/g, ''),
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.tur = eleman.tur;
                    elemanIc.miktar = eleman.miktar;
                    getData.push(eleman);
                });
                this.setState({tasimalar:getData});
                let content = getData.map((item) =>
                                 (<tr>
                                    <td>{this.state.plaka}</td>  
                                    <td>{turler[item.tur]} €</td>  
                                    <td>{item.miktar} €</td>  
                                </tr>));
                    this.setState({content:content});
            });
    }
    onChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }
    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu sorgulama="active"/>
                <PageContext>
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">SORGULA</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">PLAKA</label>
                                    <input type="text" className="form-control" name="plaka" onChange={this.onChange} value={this.state.plaka}
                                           placeholder="Plaka"/>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button onClick={this.handlePageClick} type="button" className="btn btn-primary">Sorgula</button>
                            </div>
                        </form>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Bilgileri</h3>
                        </div>
                        <div className="card-body">
                        <CustomTable state={this.state} getTotalRow={this.getTotalRow} handlePageClick={this.handlePageClick}></CustomTable>

                        </div>
                    </div>
                </PageContext>
                <Footer/>
            </div>);
    }
}


export default Sorgulama;
